
import { defineComponent } from 'vue';
import modals, { modalsNames } from '@/utils/modals';
import { useRouter } from 'vue-router';
import CommonModal from './CommonModal.vue';
import CommonButtonPrimary from './CommonButtonPrimary.vue';
import CommonButtonSecondary from './CommonButtonSecondary.vue';

export default defineComponent({
  name: 'ModalNicknameInfo',
  components: { CommonModal, CommonButtonPrimary, CommonButtonSecondary },

  setup() {
    const router = useRouter();

    const modalName = modalsNames.modalNicknameInfo;

    const onClose = modals.modalNicknameInfo.closeModal;

    const goToProfile = () => router.push('/profile');

    return {
      modalName,
      onClose,
      goToProfile,
    };
  },
});
